// extracted by mini-css-extract-plugin
export default {"list":"NumberedList_list__10QTL","number":"NumberedList_number__Pigip","children":"NumberedList_children__Id2xc"};